import { render, staticRenderFns } from "./OnTheRoad.vue?vue&type=template&id=45538c24&"
import script from "./OnTheRoad.vue?vue&type=script&lang=js&"
export * from "./OnTheRoad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports